<template>
	<div class="flex flex_between">
		<md-field :class="{ 'select-error': isError }">
			<label>{{ $t("seller.upload.manual.option.select.title") }}*</label>
			<TbSelect v-model="typeId"
					  @md-selected="onSelect"
					  :search-allow="false"
					  :options="filteredOptions"
					  options-value-field="num"
					  :disabled="disabled"
					  :options-display-getter="(item) => $t(item.title)"
			/>
		</md-field>
	</div>
</template>
<script>
import enumStatus from "@/common/enum";

export default {
	props: {
		typeId: [String, Number],
		disabled: { type: Boolean, default: false },
		exclude: { type: Array, default: [] },
	},
	data() {
		return {
			typeValue: "",
			filteredOptions: enumStatus.upTypeList.filter(item => !this.exclude.includes(item.num))
		};
	},
	mounted() {
		this.typeValue = this.typeId;
	},
	methods: {
		onSelect() {
			this.$emit("onSelect", this.typeValue);
		}
	},
	watch: {
		typeId() {
			this.typeValue = this.typeId;
		}
	}
};
</script>
